import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Country } from "../address/Country";
import { AdminPortalAPIHttpClient } from "../../infrastructure/http/v2/AdminPortalAPIHttpClient";

@Injectable({ providedIn: 'root' })
export class CountryService {

    private countries: Country[] = [];

    constructor(private adminPortalApiHttpClient: AdminPortalAPIHttpClient) { }

    async getCountries(): Promise<Country[]> {
        if(this.countries.length > 0) {
            return Promise.resolve(this.countries);
        }

        try {
            const response: any = await firstValueFrom(this.adminPortalApiHttpClient.get('/reference/countries'));
            if(!response) {
                return Promise.reject('Error while retrieving countries');
            }

            this.countries = response.data;
            return Promise.resolve(this.countries);
        } catch (e) {
            return Promise.reject(`Error while retrieving countries: ${JSON.stringify(e)}`);
        }
    }

    async getCountryFromId(countryId: number): Promise<Country | undefined> {
        try {
            const countries = await this.getCountries();
            return countries.find(country => country.id == countryId);
        } catch (e) {
            return Promise.reject(`Error while retrieving country from id ${countryId}: ${JSON.stringify(e)}`);
        }
    }

    async getCountryFromCode(code: string): Promise<Country | undefined> {
        try {
            const countries = await this.getCountries();
            return countries.find(country => country.code == code);
        } catch (e) {
            return Promise.reject(`Error while retrieving country from code ${code}: ${JSON.stringify(e)}`);
        }
    }
}